import { mutationTypes } from '@/core/constants'

export default {
	[mutationTypes.FORNECEDOR_ITEM_ATA.SET_ID_ITEM_BUSCAR_FORNECEDORES](state, id) {
		state.idItemBuscarFornecedores = id
	},
}
